import React from "react";
import RecentsPost from "../../components/Landing/RecentsPost";
import PopularPost from "../../components/Landing/PopularPost";
import ExclusifPost from "../../components/Landing/ExclusifPost";
import Banner from "../../components/Landing/Banner";
import { usePost } from "../../core/contexts/PostProvider";

const LandingPage = () => {
  const { posts, recents, populars, exclusifs } = usePost();
  return (
    <div className="relative bg-white overflow-hidden px-4">
      {posts && <Banner data={posts} />}
      {recents && <RecentsPost data={recents} />}
      {populars && <PopularPost data={populars} />}
      {exclusifs && <ExclusifPost data={exclusifs} />}
    </div>
  );
};

export default LandingPage;
